import React, { useContext, useEffect } from "react";
import "./Products.css";
import "./ResponsiveProduct.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Table } from "react-bootstrap";
import FooterTwo from "../../components/footerTwo/FooterTwo";
import { dataContext } from "../../context/DataContextProviderr";
import LoadingPage from "../../components/loadingPage/LoadingPage";

const Products = ({ indexProducts }) => {
  const { allProducts, isLoadingProduct } = useContext(dataContext);
  // useEffect(() => {
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // }, []);

  const tbldata = require("../../data.json");

  return (
    <>
      {isLoadingProduct ? (
        <LoadingPage />
      ) : (
        <div className="products">
          <div className="slider-container">
            <Swiper
              direction={"vertical"}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper"
              initialSlide={indexProducts}
              rewind={true}
            >
              {allProducts &&
                allProducts
                  ?.filter((f) => f.summary === "products")
                  ?.map((item, index) => {
                    let m = tbldata.filter((data) => {
                      return data.id === item.id;
                    })[0];
                    return (
                      <SwiperSlide key={index}>
                        <div
                          className="left"
                          style={{
                            backgroundImage: `url(${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=0&imageName=${item.image})`,
                          }}
                        ></div>
                        <div
                          className="right"
                          style={{
                            backgroundColor: `${
                              JSON.parse(item?.specification)?.filter(
                                (f) => f.Key === "bg"
                              )[0].Value
                            }`,
                          }}
                        >
                          <div className="pagination">
                            <p>{index + 1}</p>
                            <p>/</p>
                            <p>
                              {allProducts &&
                                (allProducts.sort())?.filter(
                                  (f) => f.summary === "products"
                                )?.length}
                            </p>
                          </div>
                          <div className="title">
                            <p>{item?.title}</p>
                          </div>
                          <div className="description">
                            <p>
                              {
                                JSON.parse(item?.specification)?.filter(
                                  (f) => f.Key === "description"
                                )[0].Value
                              }
                            </p>
                          </div>
                          <div className="flour-type">
                            {/* <table>
                              <tr>
                                <th> خاکستر%</th>

                                <th>رطوبت%</th>
                                <th>گلوتن%</th>
                                <th>پروتئین%</th>
                                <th colspan="4">دانه بندی</th>
                              </tr>
                              <tr>
                                <th rowspan="2">{m.khakestar}</th>
                                <td rowspan="2">{m.Rotoobat}</td>
                                <td rowspan="2">{m.geloten}</td>
                                <td rowspan="2">{m.protein}</td>
                                <td>
                                  475<i>&micro;</i>
                                </td>
                                <td>
                                  180<i>&micro;</i>
                                </td>
                                <td>
                                  125<i>&micro;</i>
                                </td>
                                <td>سینی</td>
                              </tr>
                              <tr>
                                <td>{m.A}</td>
                                <td>{m.B}</td>
                                <td>{m.C}</td>
                                <td>{m.D}</td>
                              </tr>
                            </table> */}

                            {JSON.parse(item?.specification)
                              ?.filter((f) => f.Key === "type")
                              ?.map((i, indx) => {
                                return <p key={indx}>{i.Value}</p>;
                              })}
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
            </Swiper>
          </div>
          <div className="table-quality" id="quality">
            <div className="table-bg">
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>نوع آرد</th>
                    
                    <th>خاکستر</th>
                    <th>گلوتن</th>
                    <th>پروتئین</th>
                    <th>مصارف</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>آرد نول نرم</td>
                    <td>0.380-0.500</td>
                    <td>20-27</td>
                    <td>7-10</td>
                    <td>قنادی- شیرینی‌پزی– کیک پزی</td>
                    
                  </tr>
                  <tr>
                    <td>آرد نول زبر</td>
                    <td>0.380-0.500</td>
                    <td>20-27</td>
                    <td>7-11</td>
                    <td>ماکارونی و خمیر پیتزا</td>
                    
                  </tr>
                  <tr>
                    <td>آرد ستاره</td>
                    <td>0.501-0.700</td>
                    <td>کمینه 26</td>
                    <td>کمینه 11</td>
                    <td>نان‌های حجیم و نیمه حجیم و برخی از شیرینی‌ها</td>
                    
                  </tr>
                  <tr>
                    <td>آرد بربری</td>
                    <td>0.701-0.850</td>
                    <td>کمینه 26</td>
                    <td>کمینه 11</td>
                    <td>نان‌های نیمه حجیم و نان بربری</td>
                    
                  </tr>
                  <tr>
                    <td>آرد تافتون و لواش</td>
                    <td>0.851-1.225</td>
                    <td>کمینه 25</td>
                    <td>کمینه 11</td>
                    <td>نان‌های تخت مانند تافتون و لواش</td>
                    
                  </tr>
                  <tr>
                    <td>آرد سنگگ</td>
                    <td>1.226-1.500</td>
                    <td>کمینه 24</td>
                    <td>کمینه 11.5</td>
                    <td>نان‌های سنتی و سنگک</td>
                    
                  </tr>
                  <tr>
                    <td>آرد کامل</td>
                    <td>کمینه 1.500</td>
                    <td>کمینه 23</td>
                    <td>کمینه 12</td>
                    <td>نان‌های سنتی و سنگک</td>
                    
                  </tr>
                  <tr>
                    <td>آرد ماکارونی</td>
                    <td>بیشینه 0.650</td>
                    <td>-</td>
                    <td>کمینه 12</td>
                    <td>تولید انواع پاستا</td>
                    
                  </tr>
                  <tr>
                    <td>سمولینا</td>
                    <td>0651-0.750</td>
                    <td>-</td>
                    <td>کمینه 12.5</td>
                    <td>انواع محصولات خمیری و ماکارونی</td>
                    
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>

          <FooterTwo />
        </div>
      )}
    </>
  );
};

export default Products;
